const SHOW_PROMPT_ACTIVITY_LOG_KEY = 'designstudio.showPromptActivityLog';

let memoryPreference: boolean | undefined;

type LocalStorageLike = {
  readonly getItem: (key: string) => string | null;
  readonly setItem: (key: string, value: string) => void;
  readonly removeItem: (key: string) => void;
};

function readStorage(): LocalStorageLike | undefined {
  if (typeof globalThis === 'undefined') {
    return undefined;
  }
  try {
    const storage = (globalThis as { readonly localStorage?: LocalStorageLike }).localStorage;
    if (storage === undefined) {
      return undefined;
    }
    const probeKey = `${SHOW_PROMPT_ACTIVITY_LOG_KEY}.probe`;
    storage.setItem(probeKey, '1');
    storage.removeItem(probeKey);
    return storage;
  } catch {
    return undefined;
  }
}

/** Floating prompt activity log (default: hidden). */
export function readShowPromptActivityLog(): boolean {
  const storage = readStorage();
  if (storage !== undefined) {
    return storage.getItem(SHOW_PROMPT_ACTIVITY_LOG_KEY) === '1';
  }
  return memoryPreference === true;
}

export function writeShowPromptActivityLog(enabled: boolean): void {
  const storage = readStorage();
  if (storage !== undefined) {
    if (enabled) {
      storage.setItem(SHOW_PROMPT_ACTIVITY_LOG_KEY, '1');
    } else {
      storage.removeItem(SHOW_PROMPT_ACTIVITY_LOG_KEY);
    }
  }
  memoryPreference = enabled ? true : undefined;
}
